<template>
	<div>
		<div v-if="basketEmptied" class="alert alert-info alert-dismissible fade show" role="alert">
			<strong>Tyres removed! - </strong> It isn't possible to add both fully fitted and delivered tyres to your order. Any tyres you had previously selected have been removed from your basket.
			<button type="button" class="btn-close" @click="basketEmptied = false" data-bs-dismiss="alert" aria-label="Close"></button>
		</div>
		<div class="col-12">
			<div class="border-thin rounded-lg p-3 pb-2">
				<your-vehicle
					v-if="registration != null"
					:registration="registration"
					:make="make"
					:model="model"
					:image-base-path="imageBasePath"
					:postcode="updatedPostcode"
					:size-options="sizeOptions"
				></your-vehicle>
				<div class="row py-2">
					<toggle-route :parent-home-delivery="this.homeDelivery" @routeToggled="this.routeToggled"></toggle-route>
					<check-availability
						:postcode="this.updatedPostcode"
						@updatedPostcode="updatePostcode"
					></check-availability>
				</div>
			</div>
		</div>
		<filters
			:filters="updatedFilters"
			:is-disabled="isDisabled"
		></filters>
		<div class="row">
			<featured-top-spot
				v-if="updatedFeaturedTopSpot"
				:tyre="updatedFeaturedTopSpot"
				:postcode="this.updatedPostcode"
				:basket="updatedBasket"
				:banners="banners"
			></featured-top-spot>
			<featured-tyres
				v-if="updatedFeaturedTyres"
				:featured-tyres="updatedFeaturedTyres"
				:basket="updatedBasket"
				:banners="banners"
				:postcode="this.updatedPostcode"
			></featured-tyres>
			<!-- <banners :banners="banners" :page="'select_tyres'" class="my-3"></banners> -->
			<banner-carousel v-if="banners.length > 0 && banners != null" :banners="banners" :page="'select_tyres'" class="mb-3"></banner-carousel>
			<tyres
				:banners="banners"
				:tyres="updatedTyres"
				:featured-tyres="updatedFeaturedTyres"
				:basket="updatedBasket"
				:total-tyres="updatedTotalTyres"
				:tyre-size="tyreSize"
				:infinite-reset="infiniteReset"
				:postcode="this.updatedPostcode"
				:tyre-ads="this.tyreAds"
				:tyre-size-content="tyreSizeContent"
				:pay-with-paypal="payWithPaypal"
			></tyres>
			<teleport to="body">
				<basket-modal
					:basket="this.updatedBasket"
					:modal-open="modalOpen"
					:postcode="updatedPostcode"
					:tyre-position="tyrePosition"
					:size-options="sizeOptions"
					@closeModal="modalOpen = false"
				></basket-modal>
				<upsell-modal
					:current-tyre="this.currentTyre"
					:upsold-tyre="upsoldTyre"
					:upsell-details="upsellDetails"
					:upsell-modal-open="upsellModalOpen"
					:image-base-path="imageBasePath"
					@closeModal="upsellModalOpen = false"
				></upsell-modal>
			</teleport>
		</div>
	</div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    import basket from '@shared/mixins/basket';

	export default {
	    props: [
			'featuredTopSpot',
			'featuredTyres',
			'tyres',
			'filters',
			'basket',
			'banners',
			'totalTyres',
			'tyreSize',
			'postcode',
			'imageBasePath',
			'tyreAds',
			'selectTyresTakeover',
			'homeDeliveryRoute',
			'tyrePosition',
			'sizeOptions',
			'tyreSizeContent',
			'customTyreUrl',
			'registration',
			'payWithPaypal',
			'make',
			'model'
		],
		mixins: [url_filters, basket],
	    data() {
	        return {
	            modalOpen: false,
	            updatedBasket: this.basket,
				updatedFeaturedTopSpot: this.featuredTopSpot,
				updatedFeaturedTyres: this.featuredTyres,
				updatedTyres: this.tyres,
				updatedTotalTyres: this.totalTyres,
				updatedFilters: this.filters,
				sortValue: '',
				updatedPostcode: this.postcode,
				basketEmptied: false
			}
	    },
	    mounted() {
            //removes loading placeholder - fixes CLS issue
            document.querySelector('#loadingPlaceholder').style.display = 'none';

			this.updateAllTyreFittingAvailability();

            this.emitter.on('basketEmptied', data => {
                this.basketEmptied = true;
            });
	    },
	    methods: {
			updatePostcode(value) {
				this.updatedPostcode = value;
			}
	    },
	    computed: {
	    },
		watch: {
        }
	}
</script>